import script from "./layout.vue?vue&type=script&setup=true&name=DashboardLayout&lang=js"
export * from "./layout.vue?vue&type=script&setup=true&name=DashboardLayout&lang=js"

import "./layout.vue?vue&type=style&index=0&id=296f7419&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296f7419"]])

export default __exports__